$(document).on('init:paymentmodal.nearme', function() {
  $(document).trigger('init:creditcardform.nearme');
});



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/payment_modal.initializer.js